import {omitNullsy, serializeJSONToString, useApiQuery, useCurrentLocale} from '@wallaby-ui/core';
import {useMemo} from 'react';

import {UzisReportFilter} from './uzisreporttypes';
import {ShortcutEnum} from '@wallaby-ui/document';

export type UzisReportParams = {
  dateFrom?: string | null;
  dateTo?: string | null;
  floatingShortcutName?: ShortcutEnum | null;
  organizationIds?: number[] | null;
  includeDrugChanges?: string | null;
  language?: string | null;
};

export function useUzisReportParams(filters: UzisReportFilter): UzisReportParams {
  const locale = useCurrentLocale();

  return useMemo(
    () =>
      omitNullsy({
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
        floatingShortcutName: filters.floatingShortcutName,
        organizationIds: filters.organizationIds,
        includeDrugChanges: filters.includeDrugChanges,
        language: locale.toUpperCase(),
      }),
    [filters.floatingShortcutName, filters.dateFrom, filters.dateTo, filters.organizationIds, filters.includeDrugChanges, locale]
  );
}

export function useUzisEndpointQuery<T>(args: {
  reportUrl: string;
  path: string; // "/v" | "/vi" | ...
  params: UzisReportParams;
  enabled: boolean;
  warnOnError?: string;
}) {
  const {reportUrl, path = '', params, enabled, warnOnError} = args;

  return useApiQuery<T>([`${reportUrl}${path}`, serializeJSONToString(params)], null, {
    axiosConfig: {
      url: `${reportUrl}${path}`,
      params: new URLSearchParams(params as any),
    },
    reactQueryOptions: {
      enabled,
      onError: () => {
        if (warnOnError) console.warn(warnOnError);
      },
    },
  });
}
